/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterZ = createReactComponent("outline", "letter-z", "IconLetterZ", [["path", { "d": "M7 4h10l-10 16h10", "key": "svg-0" }]]);

export { IconLetterZ as default };
//# sourceMappingURL=IconLetterZ.mjs.map
